export default {
  menus: {
    accounts: "Accounts",
    catalogues: "Catalogues",
    clients: "Clients",
    members: "Members",
    merchants: "Merchants",
    admin: "Admin",
    registrations: "Registrations",
    provisions: "Provisions",
    users: "Users",
    dashboard: "Dashboard",
    programmes: "Programmes",
    orders: "Orders",
    list: "List",
    returns: "Returns",
    products: "Products",
    price_book: "Price Book",
    categories: "Categories",
    collections: "Collections",
    attributes: "Attributes",
    marketing: "Marketing",
    promotions: "Promotions",
    banners: "Banners",
    content: "Content",
    pages: "Pages",
    customers: "Customers",
    sites: "Sites",
    settings: "Settings",
    inventory: "Inventory",
    po: "Purchase Orders",
    dealers: "Dealers",
    targets: "Targets",
    sellout: "Sellout",
    invoiced: "Invoiced",
    reports: "Download Report",
  },
};
